import React, { FC } from 'react';
import styled from 'styled-components';
import { PageMainContentId } from 'constants/Global';
import withPolarisProvider from 'lib/withPolarisProvider';
import { Base } from 'styled';
import ErrorPage from 'styled/components/ErrorPage';

import type { Quiz as IQuiz } from 'types';

import QuizModuleSwitch from 'components/QuizModuleSwitch';
import { QuizMeta } from 'components/Meta';
import { QuizMetaInfo } from 'styled';
import { MainBodyContainer } from 'components/ArticleContent/style';
import Breadcrumbs from 'styled/components/Breadcrumbs';
import { useGlobalSettings } from 'state/selectors/globalSettings';
import useLanguage from 'hooks/useLanguage';
import { RouteMap } from 'constants/Routes';
import { useRouter } from 'next/router';

export const Title = styled.h1`
  ${({ theme }) => theme.typography.variants.primary.xl};
`;

const Content = styled(Base)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
`;

export const MainInnerAndSidePanelsContainer = styled(Base)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

interface Props {
  quiz: IQuiz | null;
}

const QuizView: FC<Props> = ({ quiz }) => {
  const globalSettings = useGlobalSettings();
  const Language = useLanguage();
  const router = useRouter();

  if (!quiz) {
    return <ErrorPage errorPage={globalSettings.errorPage} />;
  }

  const { quizType } = quiz;

  return (
    <>
      <QuizMeta quiz={quiz} />
      <Breadcrumbs
        crumbConfig={[
          {
            label:
              quizType === 'Dx'
                ? Language.t('Quiz.dxQuizzes')
                : Language.t('Quiz.sxQuizzes'),
            ariaLabel:
              quizType === 'Dx'
                ? Language.t('Quiz.dxQuizzes')
                : Language.t('Quiz.sxQuizzes'),
            to: `${RouteMap.QUIZ.base}/${quizType === 'Dx' ? 'diagnosis-quiz' : 'symptom-quiz'}`,
            isActive: false,
          },
          {
            label: quiz.title,
            ariaLabel: quiz.title,
            to: router.asPath,
            isActive: true,
          },
        ]}
      />
      <MainBodyContainer className="py-6 sm:py-12">
        <Content id={PageMainContentId}>
          <Title className="text-left">{quiz.title}</Title>
          <QuizMetaInfo quiz={quiz} />
          <div className="color-gray-100 relative w-full">
            {!!quiz.modules.length && (
              <QuizModuleSwitch modules={quiz.modules} />
            )}
          </div>
        </Content>
      </MainBodyContainer>
    </>
  );
};

export default withPolarisProvider(QuizView);
